import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';

// Debounced SSM param-name typeahead. Calls onPick(name) when a name is chosen.
export default function SsmParamPicker({ onPick }) {
  const [q, setQ] = useState('');
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    const handle = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/ssm/parameters`, {
          params: { q }, withCredentials: true,
        });
        if (active) setNames(res.data.names || []);
      } catch {
        if (active) setNames([]);
      } finally {
        if (active) setLoading(false);
      }
    }, 250);
    return () => { active = false; clearTimeout(handle); };
  }, [q]);

  const trimmed = q.trim();
  const canUseTyped = trimmed.length > 0 && !names.includes(trimmed);

  return (
    <div className="apps-ssm-picker">
      <input
        type="text"
        placeholder="Search Parameter Store names…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      {loading && <span className="apps-ssm-loading">Searching…</span>}
      <ul className="apps-ssm-results">
        {names.map((n) => (
          <li key={n}>
            <button type="button" onClick={() => onPick(n)}>{n}</button>
          </li>
        ))}
        {!loading && names.length === 0 && <li className="apps-ssm-none">No matches.</li>}
      </ul>
      {canUseTyped && (
        <div className="apps-ssm-freetype">
          <button
            type="button"
            className="btn btn-small btn-secondary"
            onClick={() => onPick(trimmed)}
          >
            Use “{trimmed}”
          </button>
        </div>
      )}
      <p className="apps-ssm-hint">
        Not in the list? Type the exact Parameter Store name and use it directly.
      </p>
    </div>
  );
}
